module.exports = __webpack_public_path__ + "static/img/MV2.53f3e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV2.jpg
// module id = b0tD
// module chunks = 0